import * as tslib_1 from "tslib";
import React from 'react';
import { withPerspectiveContext } from '../Context';
var withScrollableContainer = function (ChildComponent) {
    var ChildComponentWrapper = function (_a) {
        var getScrollableContainer = _a.getScrollableContainer, getZeroPerspectiveContainer = _a.getZeroPerspectiveContainer, props = tslib_1.__rest(_a, ["getScrollableContainer", "getZeroPerspectiveContainer"]);
        var getScrollableContainerOrWindow = function () {
            var scrollableContainer = getScrollableContainer();
            if (scrollableContainer) {
                return scrollableContainer;
            }
            else if (typeof window !== 'undefined') {
                return window;
            }
            return null;
        };
        var getScrollableContainerOrBody = function () {
            var scrollableContainer = getScrollableContainer();
            if (scrollableContainer) {
                return scrollableContainer;
            }
            else if (typeof document !== 'undefined') {
                return document.body;
            }
            return null;
        };
        var getScrollableContainerHeight = function () {
            var scrollableContainer = getScrollableContainer();
            if (scrollableContainer) {
                return scrollableContainer.clientHeight;
            }
            else if (typeof window !== 'undefined') {
                return window.innerHeight;
            }
            return 0;
        };
        var getScrollHeight = function () {
            var element = getScrollableContainerOrBody();
            return (element && element.scrollHeight) || 0;
        };
        var getScrollTop = function () {
            var scrollableContainer = getScrollableContainer();
            if (scrollableContainer) {
                return scrollableContainer.scrollTop;
            }
            else if (typeof window !== 'undefined') {
                return window.scrollY;
            }
            return 0;
        };
        return (React.createElement(ChildComponent, tslib_1.__assign({ getScrollableContainerOrWindow: getScrollableContainerOrWindow, getScrollableContainerOrBody: getScrollableContainerOrBody, getScrollableContainerHeight: getScrollableContainerHeight, getScrollHeight: getScrollHeight, getScrollTop: getScrollTop }, props)));
    };
    return withPerspectiveContext(ChildComponentWrapper);
};
export default withScrollableContainer;
//# sourceMappingURL=withScrollableContainer.js.map